(() => {
  const CHECKOUT_ACTION = "/en-de/cart";
  const CHECKOUT_BUTTON_SELECTOR = 'button[name="checkout"], input[name="checkout"]';
  const FIXED_FLAG = "data-checkout-action-fixed";

  function hasCheckoutButton(form) {
    if (!form || form.tagName !== "FORM") return false;
    return form.querySelector(CHECKOUT_BUTTON_SELECTOR) != null;
  }

  function fixFormAction(form) {
    if (!form || form.getAttribute(FIXED_FLAG) === "1") return;
    if (!hasCheckoutButton(form)) return;

    if (form.action.includes("staging")) return;

    form.setAttribute("action", CHECKOUT_ACTION);
    form.setAttribute(FIXED_FLAG, "1");
  }

  function fixForms(root = document) {
    root.querySelectorAll?.("form").forEach((form) => fixFormAction(form));
  }

  // Fix any forms already on the page
  fixForms(document);

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue; // ELEMENT_NODE

        if (node.tagName === "FORM") {
          fixFormAction(node);
        }
        fixForms(node);
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.__stopFixCheckoutFormAction = () => observer.disconnect();
})();
